<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="box mt-2">
          <div class="heading">
            <h3>{{ $t('masterData.title') }}</h3>
          </div>
          <table v-if="tables.length > 0" class="table table-sm table-list table-hover mt-2">
            <thead>
            <tr>
              <th>{{ $t('masterData.tableNameHeader') }}</th>
              <th class="text-center">{{ $t('masterData.rowCountHeader') }}</th>
              <th>{{ $t('masterData.lastUpdatedHeader') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="table in tables" :key="table.name">
              <td>
                <router-link
                  :to="{ name: 'admin.master-data.show', params: { tableName: table.name } }"
                  class="text-decoration-none"
                >
                  {{ table.name }}
                </router-link>
              </td>
              <td class="text-center">{{ table.rowCount.toLocaleString() }}</td>
              <td>{{ table.lastUpdatedAt ?? '-' }}</td>
            </tr>
            </tbody>
          </table>
          <div v-else class="text-center mt-4">
            <div v-if="isLoading">{{ $t('masterData.loading') }}</div>
            <div v-else>{{ $t('masterData.noTablesFound') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue';
import axios from 'axios';

const tables = ref([]);
const isLoading = ref(true);

/**
 * マスタデータテーブル一覧を取得
 */
const fetchTables = async () => {
  try {
    isLoading.value = true;
    const response = await axios.get('/api/admin/master-data');
    tables.value = response.data.tables;
  } catch (error) {
    console.error('Error fetching master data tables:', error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  fetchTables();
});
</script>